
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artificial-intelligence-technology",
      function () {
        return require("private-next-pages/artificial-intelligence-technology/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artificial-intelligence-technology"])
      });
    }
  